import type { AdjustPicklistItemRequest } from '../types';
import type { AdjustForm, AdjustModel } from './adjustModel';

/**
 * PT-6 B — the Adjust v2 payload: the model's plan (rows and their dispositions), the reason and the note, and the
 * version the dialog captured. It never carries a move: a Move is its own request (`buildMoveRequest`, PT-6b). Null when there is nothing Apply may send, including a snapshot with no
 * version: the dialog never sends an empty `version` (the server would refuse it with "Version is required").
 */
export function buildAdjustRequest(
  model: AdjustModel,
  form: AdjustForm,
  version: string | null | undefined,
): AdjustPicklistItemRequest | null {
  if (!model.canApply || !version) return null;
  const notes = form.notes.trim();
  return {
    version,
    reason: form.reason,
    notes: notes ? notes : null,
    rows: model.plan.rows,
    moves: [],
    dispositions: model.plan.dispositions,
  };
}
